import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Road_Barrier: React.FC<Props> = ({ fill }) => {
    return (
        <Svg id="Layer_1" viewBox="0 0 64 64" width="12pt" height="100%" fill={fill}>
            <Path d="m61 12h-3v-3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3h-40v-3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3h-3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h3v4h-3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h3v10h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3v-10h40v10h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3v-10h3c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1h-3v-4h3c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1zm-19.15 2h12.52l-2.39 8h-12.52c.43-1.44 1.96-6.56 2.39-8zm-25.05 0h12.53l-2.4 8h-12.52zm-8.8-4h2v2h-2zm0 14h2v4h-2zm2 26h-2v-10h2zm12.15-12h-12.52l2.39-8h12.52zm25.05 0h-12.53c.43-1.44 1.97-6.56 2.4-8h12.52zm4.8-10h-40v-4h40zm4 22h-2v-10h2zm0-22h-2v-4h2zm0-16h-2v-2h2z" />
        </Svg>
    );
};

export default Road_Barrier;
